import { EyeOutlined }     from '@ant-design/icons';
import HeaderButton        from '@/TokamapEditor/ux/Header/HeaderButton';
import currentEditorStore  from '@/TokamapEditor/stores/currentEditorStore';
import { openPreview }     from '@/TokamapEditor/ux/Header/PreviewModal';

const PreviewButton = () => {
	if (!currentEditorStore.isCenterDefined) return null;

	return (
		<HeaderButton icon={<EyeOutlined />} onClick={() => openPreview()}>
			Aperçu
		</HeaderButton>
	);
};

export default PreviewButton;
